export default __webpack_public_path__ + "media/apps/Configurator/images/Saver-Options-Logo-23aa48241f697628f718bcc91fb23d59.png";